import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[scrollNav]'
})
export class ScrollDirective {

  constructor() { }

  @HostBinding('class.sticky-nav') stickyNav: boolean = false;

  @HostListener('window:scroll') onScroll(){
    if(window.scrollY >= 20){
      this.stickyNav = true;
    }
    else{
      this.stickyNav = false;
    }
  }

}
